import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PolicyViolationRentalDataModel')
export default class PolicyViolationRentalDataModel {
  @JsonProperty('price', Number) public price:number = undefined;
  @JsonProperty('policy_car_category', String) public policyCarCategory:string = '';
  @JsonProperty('policy_price', Number) public policyPrice:number = -1;
}
